export class UnexpectedError extends Error {
  constructor () {
    super('서버에 문제가 발생했습니다. 잠시 후 이용해주세요.')
    this.name = 'UnexpectedError'
  }
}
